module.exports = __webpack_public_path__ + "static/media/aboutUs4.c36baf51.jpg";